// Pure, i18n-free helpers for the per-channel PoolShare gain badge (feed post header).
// The rate itself is owned and computed by the backend (sum of active PoolShare earning
// programs, as a human percent number — `1`, `3`, `2.5`); this layer is purely
// presentational: value → visual tier, and value → Western-digit display string.
//
// Contract notes (see ../backend brief 2026-06-26-channel-poolshare-gain-rate-be-delivered):
//   • null / undefined / <= 0  ⇒ no active program ⇒ badge hidden (tier null).
//   • No hard ceiling; values >= 5 clamp to the top (gold) tier but show the true number.

// Tier thresholds (lower bound inclusive):
//   [1, 2) calm · [2, 4) green · [4, 5) purple · >= 5 gold (clamped top tier)
export function poolShareRateTier(rate) {
  if (rate == null || rate <= 0) return null;
  if (rate < 2) return 'calm';
  if (rate < 4) return 'green';
  if (rate < 5) return 'purple';
  return 'gold';
}

// Western-digit percent string, e.g. 3 → "3%", 2.5 → "2.5%". A plain template is used
// deliberately: toLocaleString('ar') / vue-i18n $n emit Arabic-Indic numerals, which
// violate the owner-locked Western-digits rule for member-facing UI.
export function formatPoolShareRate(rate) {
  if (rate == null) return '';
  return `${rate}%`;
}
